export default "__VITE_ASSET__CZtL2rJ5__"